<!-- ActionPopup.vue -->
<template>
  <div ref="popupRef" class="relative inline-block">
    <!-- Trigger button -->
    <button @click="isOpen = !isOpen" class="rounded-lg pr-2 transition-colors">
      <svg
        class="h-5 w-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
        />
      </svg>
    </button>

    <!-- Popup menu -->
    <transition
      enter-active-class="transition-all duration-150 ease-out"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition-all duration-100 ease-in"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        v-if="isOpen"
        class="absolute left-0 top-[30%] z-50 w-32 rounded-lg border border-gray-200 bg-white shadow-lg"
      >
        <button
          @click="$emit('edit')"
          class="block w-full cursor-pointer rounded px-3.5 py-2 text-left text-sm font-normal transition-colors duration-150 hover:bg-gray-100"
        >
          {{ __('Edit') }}
        </button>
        <button
          v-if="isOwner"
          @click="$emit('delete')"
          class="block w-full cursor-pointer rounded px-3.5 py-2 text-left text-sm font-normal transition-colors duration-150 hover:bg-gray-100"
        >
          {{ __('Delete') }}
        </button>
      </div>
    </transition>
  </div>
</template>

<script setup>
  import { onMounted, onUnmounted, ref } from 'vue';

  import { __ } from '@/helpers';
  defineProps({
    isOwner: {
      type: Boolean,
      default: false
    }
  });
  const emit = defineEmits(['edit', 'delete']);

  const isOpen = ref(false);

  const popupRef = ref(null);

  const handleClickOutside = (e) => {
    if (popupRef.value && !popupRef.value.contains(e.target)) {
      isOpen.value = false;
    }
  };

  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
  });

  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
  });
</script>
